import { render } from "./CommandesPage.vue?vue&type=template&id=09002854&scoped=true"
import script from "./CommandesPage.vue?vue&type=script&lang=js"
export * from "./CommandesPage.vue?vue&type=script&lang=js"

import "./CommandesPage.vue?vue&type=style&index=0&id=09002854&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09002854"]])

export default __exports__